<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="报告期限" prop="reportDate">
                      <el-select v-model="queryCondition.reportDate" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in allDate" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                 </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code"  clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                      <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Farm" prop="farmName">
                      <el-input v-model="queryCondition.farmName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="作物" prop="cultiVarName">
                        <el-select v-model="queryCondition.cultiVarName" clearable  filterable placeholder="请选择" style="width:100%">
                          <el-option :key="index" v-for="(item,index) in cropList" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <!-- <ic-select table="TT_RMC_PRODUCE_MEDICINE_USAGE" filterable field="STATUS" clearable v-model="queryCondition.status"  style="width:100%"></ic-select> -->
                      <el-select v-model="queryCondition.status"  clearable  placeholder="请选择" style="width:100%" filterable class="multiple_sel">
                        <el-option :key="index" v-for="(item,index) in statusOption" :label="item.chineseValue" :value="item.code"></el-option>
                      </el-select>
                   </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button  size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_PROD_MEDUSAGE_ADD"  class="btn" type="primary" @click="addList">新增</el-button>
        <el-button v-acl="RMC_PROD_MEDUSAGE_DELETE"  class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-acl="RMC_PROD_MEDUSAGE_SUBMIT" class="btn" type="primary"  @click="submitData">提交</el-button>
        <el-button v-acl="RMC_PROD_MEDUSAGE_EXPORT"  class="btn" type="primary" @click="exportData" >导出</el-button>
        <el-button v-acl="RMC_PROD_MEDUSAGE_IMPORT"  class="btn" type="primary" @click="importData">批量导入</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="报告期限" min-width="100" field="reportDate">
          <template v-slot="scope">
                <el-button type="text" @click="onGrade(scope.row)">{{scope.row.reportDate}}</el-button>
            </template>
        </ux-table-column>
        <ux-table-column align="center" title="Category3" field="category3Name"  width="120" />
        <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="Farm" min-width="120" field="farmName"></ux-table-column>
        <ux-table-column align="center" title="作物" min-width="100" field="cultiVarName"></ux-table-column>
        <ux-table-column align="center" title="种植亩数" min-width="100" field="plantUnit"></ux-table-column>
        <ux-table-column align="center" title="实际使用量(kg)" min-width="120" field="realUse">
          <template v-slot="scope">
            {{scope.row.realUse?scope.row.realUse.toFixed(4):'0.0000'}}
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="农药原粉量总量(g)/种植亩数(亩)" min-width="220" field="pesticideUnit">
          <template v-slot="scope">
            {{scope.row.pesticideUnit?scope.row.pesticideUnit.toFixed(4):'0.0000'}}
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="农药原粉量总量(g)/(亩产量*种植亩数)(ton)" min-width="300" field="pesticideUnitTotal">
          <template v-slot="scope">
            {{scope.row.pesticideUnitTotal?scope.row.pesticideUnitTotal.toFixed(4):'0.0000'}}
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="状态" min-width="100" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="更新人" min-width="100" field="submitUser"></ux-table-column>
        <ux-table-column align="center" title="更新日期" min-width="120" field="submitDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    
    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">更新状态  <span style="font-weight: normal;margin-left:10px;font-size:12px;">如果无更新时，请先在日期后点击确认</span> </p>
            </div>
        </div>
       <updateDialog @close="handleClose"></updateDialog>
    </el-dialog>

    <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
      <el-row style="margin-bottom:10px">
        <el-upload ref="batchUpload" :headers="header" :action="uploadListsUrl" :on-success="uploadListsSuccess" :on-error="uploadError" :on-change="handleChange" :before-upload="beforeListsUpload" :file-list="importFileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
          <el-button size="small" type="primary">选取文件</el-button>
        </el-upload>
        <!-- <el-link type="button" target="_blank" href="static/template/qspi/RMC_Produce_Medicine_Usage.xlsx" download="RMC_Produce_药品用量导入模板.xlsx"> -->
          <el-button class="btn" type="primary" size="small" style="height:100%" @click="downloadImportTem">导入模板下载</el-button>
        <!-- </el-link> -->
      </el-row>
      <el-form :model="uploadForm" ref="uploadForm">
        <el-form-item>
          <el-input v-model="uploadForm.fileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <h4>说明:</h4>
        <ul>
          <li>1.请点击模板下载,按照模板填写后再上传</li>
          <li>2.模板中红色字段为必填项,请务必正确填写</li>
          <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
          <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
          <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
        </ul>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
      </el-row>
    </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './MaintainceFacility.vue'
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import apiService  from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";
import proMedicineDosage from '@/api/rmcProduce/proMedicineDosage'
import updateDialog from '@/components/page/RMC/Protein/rmcDrugList/updateDialog'
import proteinDrug from "@/api/rmcProtein/drug";
import { fileService } from "@/api/common/file-utils";
import prodMedicine from "@/api/rmcProduce/prodMedicine";


export default {
  name: '',
  components: {
    updateDialog,
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      uploadForm:{
        fileName: "",
      },
      dialogBatchUploadVisible:false,
      identity:localStorage.getItem('ms_emplFlag'),
      dialogVisible:false,
      allDate:[],
      multipleSelection:[],
      category3List:[],
      cropList:[],
      statusList: [],
      queryCondition: {
        appraisePeriodList: [],
        category2CodeList: [],
        category3CodeList: [],
        facilityName: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
        supplierGroupName: ""
      },
      isShow: false,
      showDetailDialog:false,
      tableData: [],
      formData:null,
      totalCount:"",
      statusView:"",
      ms_roles :JSON.parse(localStorage.getItem('ms_roles')),
      statusOption:[],
    }
  },
  computed: {
    uploadListsUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `rmc/produce/medicineUsage/importExcelForProduceMedicineUsage`;
    },
  },
  created() {
    let queryData=this.$store.state.asl.skipQuery
    let qspiInfo=JSON.parse(sessionStorage.getItem('qspiInfo'))
    if(qspiInfo){
      if(qspiInfo.SPONSOR_NAME){
        this.$set(this.queryCondition,'sponsorName',qspiInfo.SPONSOR_NAME)
      }
      if(qspiInfo.AUDIT_STATUS){
        this.$set(this.queryCondition,'status',qspiInfo.AUDIT_STATUS)
      }
    }
    if(queryData.sponsorName){
      this.$set(this.queryCondition,'sponsorName',queryData.sponsorName)
    }
    // if(queryData.category3Code){
    //   this.$set(this.queryCondition,'category3Code',queryData.category3Code)
    // }
    // if(queryData.farmGroup){
    //   this.$set(this.queryCondition,'farmGroup',queryData.farmGroup)
    // }
    this.getStatusList()
    this.getdCategory3()
    this.getSelector()
    this.queryData();
    this.getFarmGroupId()
  },
  destroyed(){
    this.$store.dispatch('saveQueryData',{})
    sessionStorage.setItem('qspiInfo', null)
  },
  methods: {
    getStatusList(){
      prodMedicine.getStatusList({
          "TT_RMC_PRODUCE_MEDICINE_USAGE:STATUS": "TT_RMC_PRODUCE_MEDICINE_USAGE:STATUS",
        }).then((res)=>{
          if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS') !== -1){
            this.statusOption =  res["TT_RMC_PRODUCE_MEDICINE_USAGE:STATUS"].filter(ele => {
              return ele.code != "DRAFT"
            })
          }else{
            this.statusOption = res["TT_RMC_PRODUCE_MEDICINE_USAGE:STATUS"];
          }
      })
    },
    getFarmGroupId(){
      proMedicineDosage.getFarmName(-1).then((res)=>{
        res.data.forEach((v)=>{
          let obj={}
          obj.name=v
          obj.code=v
          this.cropList.push(obj)
        })
      })
    },
    getdCategory3(){
      proteinDrug.getdCategory3().then((res)=>{
        this.category3List=res.data.filter((v)=>{
          return v.cascadeKey=='produce'
        })
      })
    },
    getSelector(){
      proMedicineDosage.getSelector().then((res)=>{
        res.data.forEach((v)=>{
          let obj={}
          obj.name=v
          obj.code=v
          this.allDate.push(obj)
        })
      })
    },
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      proMedicineDosage.getMedicineUsage(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    onGrade(row){
      // sessionStorage.setItem("taskDetail",JSON.stringify(row))
      this.$router.push({
          path:"/rmcProdMedUsage/detail",
          query:{
            id:row.ttRmcProduceMedicineUsageId
          }
      })
    },
    onReset() {
      this.queryCondition={
        appraisePeriodList: [],
        category2CodeList: [],
        category3CodeList: [],
        facilityName: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
        supplierGroupName: ""
      }
      this.queryCondition.pageNum=1
      this.queryData();
    },
    addList() {
      this.$router.push({
          path:"/rmcProdMedUsage/detail",
          query:{

          }
      })
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    submitData(){
      if(this.multipleSelection.length==0){
        this.$message.error('请先选择数据后再操作')
      }else{
        proMedicineDosage.submitData({switchParamList:this.multipleSelection}).then((res)=>{
          if(res.code==200){
            this.$message.success('提交成功')
            this.$refs.plxTable.clearSelection();
            this.multipleSelection=[]
            this.queryData()
          }else{
          this.$message.error(res.msg)
          }
        })
      }
    },
    onDel() {
      if(this.multipleSelection.length==0){
        this.$message.error('请先选择数据后再操作')
      }else{
        let isCreate=this.multipleSelection.some((v)=>{
          return v.status!='DRAFT'
        })
        if(isCreate){
          this.$message.error("仅可删除草稿状态的清单")
        }else{
          this.$confirm('请确认是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'colorBtn',
            cancelButtonClass: 'btn_custom_cancel',
            type: 'warning'
          }).then(() => {
            let params={
              produceMedicineUsageIds:[]
            }
            this.multipleSelection.forEach((v)=>{
              params.produceMedicineUsageIds.push(v.ttRmcProduceMedicineUsageId)
            })
            proMedicineDosage.deleteMedicineUsage(params).then((res)=>{
              if(res.code==200){
                this.$message.success('删除成功')
                this.queryData()
              }else{
                this.$message.error(res.msg)
              }
            })
          })
        }
      }
    },
    approve(){
        console.log("批准")
    },
    sendBack(){
        console.log("退回")
    },
    importData(){
      this.dialogBatchUploadVisible=true
      this.uploadForm.fileName=''
      this.importFileList=[]
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    downloadImportTem(){
      proMedicineDosage.importExcelTemp().then((res)=>{
          fileService.respToFile(res,'RMC_Produce_药品用量导入模板.xlsx');
      })
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.importFileList = []
    },
    beforeListsUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.importFileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    uploadListsSuccess(resp) {
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      this.dialogBatchUploadVisible = false
      this.importFileList = []
      this.uploadForm.fileName = ''
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData();
      } else {
        console.log('resp.meta.msg', resp.meta.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.meta.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
    },
    uploadError(resp) {
      this.dialogBatchUploadVisible=false
      var errorMsg = resp.toString()
      errorMsg = errorMsg.replace("Error:", "")
      errorMsg = JSON.parse(errorMsg)
      this.$message.error(errorMsg.msg)
    },
    exportData(){
        let ids=[]
        this.multipleSelection.forEach((v)=>{
          ids.push(v.ttRmcProduceMedicineUsageId)
        })
        this.queryCondition.produceMedicineUsageIds =ids
        proMedicineDosage.exportMedicineUsage(this.queryCondition).then((res)=>{
            fileService.respToFile(res,'Produce_药品用量.xlsx');
        })
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    handleClose(){
      this.dialogVisible=false
      this.queryData()
    },
    
  },
  extends: commonFunction
}
</script>
<style scoped >
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
